import { render, staticRenderFns } from "./EditDataLogs.vue?vue&type=template&id=6fec0d56"
import script from "./EditDataLogs.vue?vue&type=script&lang=js"
export * from "./EditDataLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports